import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { previewText } from "../../helpers/cellPreview";

function Url({ value, options = {} }) {
  if (isEmpty(value)) return null;
  const label = value.text || value.url;
  return (
    <a
      href={`${value.url}`}
      title={value.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {options.truncate ? previewText(label) : label}
    </a>
  );
}
Url.propTypes = {
  value: PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string,
  }),
  options: PropTypes.shape({ truncate: PropTypes.bool }),
};

export default Url;
